var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 9.333 12.333 2l6.334 7.333M23.333 9.333l-2.518 10.133c-.118.726-.434 1.377-.895 1.84-.46.463-1.035.708-1.624.693H5.704c-.59.015-1.164-.23-1.624-.693s-.777-1.114-.895-1.84L.667 9.333z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.333 17.334a2.333 2.333 0 1 0 0-4.667 2.333 2.333 0 0 0 0 4.667"
  })));
};
export default SvgCart;